<ion-app>
  <ion-menu class="app-menu" side="start" menuId="main-menu" contentId="main-content">
    <ion-header>
      <ion-toolbar>
        <ion-title>Menu</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="menu-content">
      <div class="menu-brand">
        <img src="assets/icons/ChatGPT Image 4 mag 2026, 18_59_39.png" class="menu-brand-logo" alt="Logo">
        <h1>milenalatusorella</h1>
        <p>Gestionale operativo.</p>
      </div>

      <ion-list class="menu-list">
        <ion-item-divider class="menu-divider">
          <ion-label>Navigazione</ion-label>
        </ion-item-divider>
        <ion-item class="menu-link" routerLink="/home" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon name="home-outline" slot="start"></ion-icon>
          <ion-label>Home</ion-label>
        </ion-item>
        <ion-item class="menu-link" routerLink="/sbandieratori" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon name="people-outline" slot="start"></ion-icon>
          <ion-label>Sbandieratori</ion-label>
        </ion-item>
        <ion-item class="menu-link" routerLink="/esibizioni" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon name="calendar-outline" slot="start"></ion-icon>
          <ion-label>Esibizioni</ion-label>
        </ion-item>
        <ion-item class="menu-link" routerLink="/esibizioni-archivio" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon name="archive-outline" slot="start"></ion-icon>
          <ion-label>Archivio Esibizioni</ion-label>
        </ion-item>
        <ion-item class="menu-link" routerLink="/statistiche" routerLinkActive="active" (click)="closeMenu()">
          <ion-icon name="bar-chart-outline" slot="start"></ion-icon>
          <ion-label>Statistiche</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
